export const dataTitles: { [key: string]: string } = {
  //pitch data
  ExtensionFeet: "Extension",
  HorzApprAngleDegrees: "Horz Apr Angle",
  HorzBreakInches: "Horz Break",
  HorzRelAngleDegrees: "Horz Rel Angle",
  InducedVertBreakInches: "I. Vert Break",
  plateEpochSeconds: "plateEpochSeconds",
  PlateLocHeightFeet: "Plate Ht.",
  PlateLocSideFeet: "Plate Side",
  RelHeightFeet: "Rel Height",
  RelSideFeet: "Rel Side",
  RelSpeedMPH: "Velocity",
  SpinAxisDegrees: "Spin Axis",
  SpinRateRPM: "Spin Rate",
  Tilt: `Tilt`,
  VertApprAngleDegrees: "Vert Apr Angle",
  VertBreakInches: "Vert Break",
  VertRelAngleDegrees: "Vert Rel Angle",
  yt_EffectiveSpinRPM: "yt_EffectiveSpinRPM",
  yt_FSRIPercent: "FSRI",
  yt_GyroSpinRPM: "yt_GyroSpinRPM",
  yt_HorzApprAngleDegrees: "yt_HorzApprAngleDegrees",
  yt_HorzBreakInches: "yt_HorzBreakInches",
  yt_HorzRelAngleDegrees: "yt_HorzRelAngleDegrees",
  yt_InducedVertBreakInches: "yt_InducedVertBreakInches",
  yt_OutOfPlaneDegrees: "yt_OutOfPlaneDegree",
  yt_PlateLocHeightFeet: "Plate Ht.",
  yt_PlateLocSideFeet: "Plate Side",
  yt_RelHeightFeet: "Rel Height",
  yt_RelSideFeet: "yt_RelSideFeet",
  yt_RelSpeedMPH: "YT Rel ",
  yt_SpinEfficiencyPercent: "Efficiency",
  yt_VertApprAngleDegrees: "Vert Apr Angle",
  yt_VertRelAngleDegrees: "yt_VertRelAngleDegree",
  yt_ZoneSpeedMPH: "Zone Velo",
  yt_ZoneTimeSeconds: "Zone Time",
  ZoneSpeedMPH: "Zone Velo",
  ZoneTimeSeconds: "Zone Time",
  //hit data
  AngleDegrees: "Launch Angle",
  BearingDegrees: "Bearing",
  DirectionDegrees: "Direction",
  DistanceFeet: "Distance",
  exitEpochSeconds: "exitEpochSeconds",
  ExitSpeedMPH: "Exit Velo",
  HangTimeSeconds: "Hang Time",
  HitSpinRateRPM: `Bat'd Spin Rate`,
  yt_EffectiveBattingSpeedMPH: "yt_EffectiveBattingSpeedMPH",
  yt_GroundLocationXFeet: "yt_GroundLocationXFeet",
  yt_GroundLocationYFeet: "yt_GroundLocationYFeet",
  yt_HitBreakTSeconds: "yt_HitBreakTSeconds",
  yt_HitBreakXFeet: "yt_HitBreakXFeet",
  yt_HitBreakYFeet: "yt_HitBreakYFeet",
  yt_HitLocationXFeet: "yt_HitLocationXFeet",
  yt_HitLocationYFeet: "yt_HitLocationYFeet",
  yt_HitLocationZFeet: "yt_HitLocationZFeet",
  yt_HitSpinComponentX: "yt_HitSpinComponentX",
  yt_HitSpinComponentY: "yt_HitSpinComponentY",
  yt_HitSpinComponentZ: "yt_HitSpinComponentZ",
  yt_HitVelocityXMPH: "yt_HitVelocityXMPH",
  yt_HitVelocityYMPH: "yt_HitVelocityYMPH",
  yt_HitVelocityZMPH: "yt_HitVelocityZMPH",
};
